import {Component, OnDestroy, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {FormControl} from "@angular/forms";
import {AppUtils} from "../shared/app-utils";
import {HtmlUtilsService} from "../html-utils/html-utils.service";
import {Title} from '@angular/platform-browser';
import { environment } from "../../environments/environment";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit{

  private fulltextBaseUrl = environment.fulltextUrl

  phraseField = new FormControl();

  focused = false;

  constructor(private router: Router, private htmlUtils: HtmlUtilsService, private titleService: Title) {
  }

  ngOnInit(): void {
    this.titleService.setTitle('Omnis');
  }

  search(phrase: string, searchInText: boolean = false): void {
    if (searchInText) {
      this.redirectToFulltext(phrase);
    } else {
      let filters = AppUtils.phraseToFilter(phrase).toURL();
      filters = filters.concat(',_type:-work');
      this.router.navigate(["/search/s/"], {
        queryParams: {page: 1, searchInText: searchInText, query: phrase, filters}
      })
    }
  }

  mark(focus: boolean) {
    if (focus) {
      this.markFocused();
    } else {
      this.markBlured();
    }
  }

  markFocused() {
    this.focused = true;
  }

  markBlured() {
    this.focused = false;
  }

  redirectToFulltext(phrase: string) {
    window.location.href = `${this.fulltextBaseUrl}/results?query=${phrase}`;
  }
}
